const getters = {
  userInfo: state => state.user.userInfo,
  videoIngName: state => state.user.videoIngName,
}
export default getters
